module.exports = __webpack_public_path__ + "img/Middle-Semi-Elliptical-Attachment-L-16.af2dd392.png";